import React from 'react';
import DirectNavigationModel from '../DirectNavigationModel';
import GroupView from '../GroupView/GroupView.react';
import {PropTypes} from 'prop-types';

import './GroupsView.less';

class GroupsView extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    _onGroupClick = (group) => {
        if (this.props.onGroupClick) {
            this.props.onGroupClick(group);
        }
    };

    _onSpaceClick = (space, group) => {
        if (this.props.onSpaceClick) {
            this.props.onSpaceClick(space, group);
        }
    };

    render() {
        // TODO: Check sorting for Groups and Spaces.
        return (
            <ul className={'Groups'}>
                {this.props.groups.map((group) => {
                    return (
                        <GroupView
                            group={group}
                            key={group.id}
                            onGroupClick={this._onGroupClick}
                            onSpaceClick={this._onSpaceClick}
                            withGroupLabel={this.props.groups.length > 1}
                            useMediaGateway={this.props.useMediaGateway}
                        />
                    );
                })}
            </ul>
        );
    }
}

GroupsView.propTypes = {
    groups: PropTypes.arrayOf(DirectNavigationModel.groupType).isRequired,
    onGroupClick: PropTypes.func,
    onSpaceClick: PropTypes.func,
    useMediaGateway: PropTypes.bool,
};

export default GroupsView;
